import React from "react";
import Loading from './Loading';
import { configData } from "../config";
import { liveCopyOrPlaceholder, drupalFiles } from './liveImageFallback';
import { keepLiveLinksOnSite } from "./liveSiteLinks";

// A testimonial at its own address (/testimonial/<name>, or /node/<nid> when it has no address of
// its own), as the live site shows it to visitors: the body, and above it, when the testimonial
// names its author's account, the account's picture, the title and a "« Back" link
const ViewTestimonialPage = ({page}) => {
    if (!page) {
        return <Loading />;
    }
    const placeholderImg = configData.DRUPAL_LIVE_DOMAIN_URL + '/sites/person_images/notavailable.jpg';
    const hasAuthor = Number(page.drupal_uid) > 0;
    // As on the live site: back in the browser's history, or to the testimonials list
    // (SmwwTestimonialsList.js) when this is the first page
    const testimonialsList = '/smww-testimonials';
    const goBack = (event) => {
        if (window.history.length > 1) {
            event.preventDefault();
            window.history.back();
        }
    };

    // courses-overview-container: the live theme's text styles, as on the other pages with no
    // sidebars (Page.css); drupal-editor-classes: the editor's classes, which live styles here too
    return (
        <div id={'node-' + page.nid} className="node node-testimonial courses-overview-container drupal-editor-classes">
            {/* Live's "content clearfix": "content" is this site's hidden tab (UserTab.css) */}
            <div className="clearfix">
                {hasAuthor && (
                    <>
                        <div>
                            <div className="testimonial-author-picture" style={{ float: "left" }}>
                                {/* The account's picture, else the "not available" one at 100 x 100 */}
                                {page.author_picture
                                    ? <img src={page.author_picture} alt="" onError={liveCopyOrPlaceholder(placeholderImg)} />
                                    : <img src={placeholderImg} alt="" width="100px" height="100px" />}
                            </div>
                            <div style={{ float: "left", paddingLeft: "2%", paddingTop: "2%" }}><strong>{page.title}</strong></div>
                            <div style={{ textAlign: "right" }}><a href={testimonialsList} onClick={goBack}>« Back</a></div>
                        </div>
                        <br />
                        <div style={{ clear: "both" }}></div>
                    </>
                )}
                <div className="field field-name-body field-type-text-with-summary field-label-hidden">
                    <div className="field-items">
                        <div className="field-item even" dangerouslySetInnerHTML={{ __html: drupalFiles(keepLiveLinksOnSite(page.body)) }} />
                    </div>
                </div>
            </div>
        </div>
    );
};
export default ViewTestimonialPage;
